import { Row, Col, Typography } from "antd";
import React from "react";
import { StyledLink } from "../styled-components/components";
import ImageComponent from "../Utilities/ImageComponent";
import { useHistory } from "react-router";
import AccountTypeCard from "./AccountTypeCard";

const HomeBody = () => {
  let history = useHistory();
  const goToLogin = () => {
    history.push("/login");
  };
  return (
    <Col xs={{ span: 24 }}>
      <Row>
        <ImageComponent height="100vh" />
        <Col
          xs={{ span: 20 }}
          md={{ span: 12 }}
          xl={{ span: 9 }}
          xxl={{ span: 6 }}
          style={{ margin: "auto", marginTop: "8vh" }}
        >
          <Row>
            <Typography.Title level={4}>Join Us!</Typography.Title>
          </Row>
          <Row>
            <Col sm={{ span: 18 }}>
              <Typography.Paragraph>
                To begin this journey,tell us what type of account you'd be
                opening
              </Typography.Paragraph>
            </Col>
          </Row>
          <Row>
            <AccountTypeCard
              id="client"
              accountType="CLIENT"
              accountDescription="Account where you can post a job and hire talent"
            ></AccountTypeCard>
          </Row>
          <Row>
            <AccountTypeCard
              id="consultant"
              accountType="CONSULTANT"
              accountDescription="Account where you can look for a job"
            ></AccountTypeCard>
          </Row>
          <Row>
            Already have an account ?
            <StyledLink data-testid="submit-signin" onClick={goToLogin}>
              Sign In
            </StyledLink>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default HomeBody;
